webpackJsonp([4],{

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactStatic = __webpack_require__(22);

var _reactHelmet = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
var TITLE = 'Blog';

exports.default = function () {
  return _react2.default.createElement(_reactStatic.RouteData, {
    render: function render(_ref) {
      var posts = _ref.posts;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _reactHelmet.Helmet,
          null,
          _react2.default.createElement(
            'title',
            null,
            TITLE
          )
        ),
        _react2.default.createElement(
          _reactStatic.Link,
          { to: '/' },
          '<',
          ' Home'
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'h1',
          null,
          'It\'s blog time.'
        ),
        _react2.default.createElement('br', null),
        'All Posts:',
        _react2.default.createElement(
          'ul',
          null,
          posts.map(function (post) {
            return _react2.default.createElement(
              'li',
              { key: post.id },
              _react2.default.createElement(
                _reactStatic.Link,
                { to: '/blog/post/' + post.id + '/' },
                post.title
              )
            );
          })
        )
      );
    }
  });
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Blog.ac082135.js